// extracted by mini-css-extract-plugin
export default {"del_area":"DelConfirm_del_area__yZ4MW","del_title":"DelConfirm_del_title__FH4-h","del_desc":"DelConfirm_del_desc__WB1w7"};